export const FIELD_PATTERN = /^field_(\d+)$/;
export const FIELD_PREFIX = 'field_';
export const BASE_COLUMNS_WIDTH = '150px';
export const UNIFIED_FIELD_WIDTH = '250px';
export const UNIFIED_FIELD_LABEL_PREFIX = 'Унифицированное поле ';

export const BASE_COLUMNS = [{
    id: 1,
    columnOrdinal: 1,
    label: 'Пакет загрузки',
    type: 'number',
    fieldKey: 'pkg_id',
},
{
    id: 2,
    columnOrdinal: 2,
    label: 'Номер строки',
    type: 'number',
    fieldKey: 'order_num',
},
];
